import { ObjectiveResultUpdateMode } from '../../../__generated__/graphql';

type CanEditGoalResultInput = {
  mode: ObjectiveResultUpdateMode | null;
  isManager: boolean;
  isEmployee: boolean;
};

export const resolveObjectiveResultUpdateMode = (
  mode: ObjectiveResultUpdateMode | null | undefined,
): ObjectiveResultUpdateMode => {
  return mode ?? ObjectiveResultUpdateMode.HrManager;
};

export const canEditGoalResult = (input: CanEditGoalResultInput): boolean => {
  const { mode, isManager, isEmployee } = input;
  const resolvedMode = resolveObjectiveResultUpdateMode(mode);

  switch (resolvedMode) {
    case ObjectiveResultUpdateMode.HrManagerEmployee:
      return isManager || isEmployee;
    case ObjectiveResultUpdateMode.HrManager:
      return isManager;
    case ObjectiveResultUpdateMode.HrEmployee:
      return isEmployee;
    case ObjectiveResultUpdateMode.Hr:
    default:
      return false;
  }
};

export const useCanEditGoalResult = (
  input: CanEditGoalResultInput,
): boolean => {
  return canEditGoalResult(input);
};
